import { useMemo } from "react";
import { useUsers } from "./useUsers.new";
import useSubscription from "./useSubscription";

export default () => {
  const { data: originalSubscription } = useSubscription();
  const { data } = useUsers();
  const users = data?.users;

  const availableSeats = useMemo(() => {
    if (originalSubscription) {
      const seats = originalSubscription?.userCount || 0;

      const activeUsersCount =
        users?.filter((user) => user?.kind === "member" && user?.active)
          ?.length || 0;

      return seats > activeUsersCount ? seats - activeUsersCount : 0;
    }
    return undefined;
  }, [originalSubscription, users]);

  return { availableSeats };
};
